import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as $ from 'jquery';
import {
  wrapperGetLogoUrlInApp
} from '../../javascript.js';

@Component({
  selector: 'app-help-item',
  templateUrl: './help-item.component.html',
  styleUrls: ['./help-item.component.css']
})
export class HelpItemComponent implements OnInit {

  constructor(private translateService: TranslateService) { }

  ngOnInit(): void {
    this.setLogoUrl();
  }

  setLogoUrl() {
    try {
      $("#van-logo").attr("href", wrapperGetLogoUrlInApp());
    } catch (e) { }
  }
}
